import { useAutomationCategoryUsage } from '../queries';
import styles from './CategoryEditDialog.module.css';

interface CategoryDeleteWarningProps {
  categoryId: string;
  categoryName: string;
}

const pluralize = (count: number, singular: string) =>
  `${count} ${count === 1 ? singular : `${singular}s`}`;

/** What deleting a category removes, with live usage counts. Used by CategoryEditDialog. */
export function CategoryDeleteWarning({ categoryId, categoryName }: CategoryDeleteWarningProps) {
  const { data: usage, isLoading } = useAutomationCategoryUsage(categoryId);

  const usageSummary = usage
    ? `It is on ${pluralize(usage.templateCount, 'template')} and ${pluralize(usage.tenantAutomationCount, 'tenant automation')} across ${pluralize(usage.tenantCount, 'tenant')}.`
    : '';
  const warning = isLoading
    ? 'Checking where this category is used…'
    : `Deleting “${categoryName}” removes it everywhere. ${usageSummary}`;

  return <p className={styles.deleteWarning}>{warning}</p>;
}
